<script>
  import { onDestroy, onMount } from "svelte";
  import { getStoreCategories } from "../../Common/tools";
  import ProductCategoryLeaf, { addNewCategory, saveProductCategory } from "./ProductCategory.svelte";
  import { createEventDispatcher } from "svelte";
  import {External, M} from "../../external";

  let categoryTree = [];
  let treeRoot = null,
    jqTree = null;
  const dispatch = createEventDispatcher();

  let getParentTreeFromCategory = (tree, categoryId) => {
    for (let idx = 0; idx < tree.length; ++idx) {
      let category = tree[idx];
      if (category.id === categoryId) {
        return tree;
      } else if (category.childNodes && category.childNodes.length) {
        let innerTree = getParentTreeFromCategory(category.childNodes, categoryId);
        if (innerTree) {
          return innerTree;
        }
      }
    }
    return null;
  };

  let setCategoryOrder = async (newIdx, categoryId) => {
    let tree = getParentTreeFromCategory(categoryTree, categoryId);
    if (!tree) {
      return;
    }
    let oldCategoryIdx = External.indexOfId(tree, categoryId);
    if (oldCategoryIdx >= 0 && newIdx !== oldCategoryIdx) {
      let category = tree[oldCategoryIdx];
      tree.splice(oldCategoryIdx, 1);
      tree.splice(newIdx, 0, category);
      category.order = 1;
      if (tree.length > 1) {
        if (newIdx == tree.length - 1) {
          category.order = tree[tree.length - 2].order + 1;
        } else if (newIdx === 0) {
          category.order = tree[1].order / 2;
        } else {
          category.order = (tree[newIdx - 1].order + tree[newIdx + 1].order) / 2;
        }
      }
      let result = await saveProductCategory(category);
      setTimeout(() => {
        if (!category.parentCategory) {
          onRootCategoriesChanged();
        }
        categoryTree = categoryTree;
      }, 10);
    }
  };

  let setupTree = () => {
    jqTree = External.$(treeRoot);

    jqTree.nestedSortable({
      forcePlaceholderSize: true,
      handle: ".tmdp-tree-handle",
      helper: "clone",
      items: "li",
      opacity: 0.6,
      revert: 100,
      tabSize: 450000,
      placeholder: "placeholder",
      tolerance: "pointer",
      toleranceElement: "> div",
      isTree: false,
      disableParentChange: true,
      expandOnHover: false,
      startCollapsed: false,
      branchClass: "tmdp-tree-branch",
      collapsedClass: "tmdp-tree-collapsed",
      disableNestingClass: "tmdp-tree-no-nesting",
      errorClass: "tmdp-tree-error",
      expandedClass: "tmdp-tree-expanded",
      hoveringClass: "tmdp-tree-hovering",
      leafClass: "tmdp-tree-leaf",
      disabledClass: "tmdp-tree-disabled",
      start: (event, ui) => {
        let height = ui.placeholder.height();
        ui.placeholder.css({
          height: height - 5 + "px",
          "margin-bottom": "5px"
        });
      },
      stop: function (event, ui) {
        let newIdx = ui.item.index();
        let categoryId = ui.item.data("id");
        setCategoryOrder(newIdx, categoryId);
      },
      change: () => {}
    });
  };

  let onRootCategoriesChanged = () => {
    dispatch("root-categories-changed", {
      categories: categoryTree
    });
  };

  let onCategoryDeleted = (idx) => {
    categoryTree.splice(idx, 1);
    categoryTree = categoryTree;
    onRootCategoriesChanged();
  };

  let createCategory = () => {
    let order = categoryTree.length ? categoryTree[categoryTree.length - 1].order + 1 : 1;
    addNewCategory(null, order, (category) => {
      categoryTree.push(category);
      categoryTree = categoryTree;
      onRootCategoriesChanged();
    });
  };

  let load = async () => {
    let categories = await getStoreCategories(null);
    categoryTree = [];

    const hashTable = {};

    categories.forEach((category) => (hashTable[category.id] = { ...category, childNodes: [] }));
    categories.forEach((category) => {
      if (category.parentCategory) {
        hashTable[category.parentCategory].childNodes.push(hashTable[category.id]);
      } else {
        categoryTree.push(hashTable[category.id]);
      }
    });
    categoryTree = categoryTree;
    setupTree();
  };

  onMount(load);

  onDestroy(() => {
    if (jqTree) {
      jqTree.sortable("destroy");
      jqTree = null;
    }
  });
</script>

<div class="categories-scrollable-table store-tree-wrapper mb-35" style="position: relative;">
  <div class="col20 f-left t-center mt-25">
    <a on:click={createCategory} class="middle-button inline-block f-none blue with-icon">{M.CREATE_CATEGORY}</a>
  </div>

  <ol bind:this={treeRoot} class="tmdp-tree mt-25">
    {#each categoryTree as category, idx (category.id)}
      <ProductCategoryLeaf category={category} on:deleted={() => onCategoryDeleted(idx)} />
    {/each}
  </ol>
</div>
